import React, { useCallback } from 'react';
import { connect } from 'react-redux';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import ResponsiveBox from 'components/generic/ResponsiveBox.component';
import LINK from 'constants/link.const';
import PURCHASE_VARIANTS from 'constants/sms/purchase.const';
import { useNavFor } from 'hooks/useNav.hook';
import useTip from 'hooks/useTip.hook';
import { useGilt, useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { selectClientCommsSmsCreditsAvailable } from 'selectors/clientCommunications.selectors';
import selectEffectiveUserRole from 'selectors/selectEffectiveUserRole';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import linkTo from 'utils/links/linkTo.util';

import { purchaseSmsBundle } from 'clientCommunications/actions';
import PurchaseSmsCreditDialog from 'clientCommunications/components/Clients/PurchaseSmsCreditDialog';

import CN from './SmsBuyButton.module.scss';

const SmsBuyButton = ({ tag, purchaseSmsBundle, smsError, isSmsFetching, smsCredits, permission, history }) => {
  const salonId = useCurrentSalonId();
  const { isSalonInUS } = useGilt();
  const { t } = useTranslation();
  const nav = useNavFor('SmsBuyButton()');
  const { val: renderSmsModal, tip: toggleSmsModal } = useTip(false);

  const handleButtonClick = useCallback(() => {
    if (isSalonInUS) {
      nav.push({
        pathname: linkTo({ pattern: LINK.marketing, params: { salonId } }),
      });
    }

    toggleSmsModal();
  }, [isSalonInUS, nav, salonId, toggleSmsModal]);

  return (
    <div className={CN.component} data-bem="SmsBuyButton" data-tag={fromAnyToTrimmed(tag)}>
      <Button data-bem="SmsBuyButton__button" className={CN.button} onClick={handleButtonClick}>
        <Icon variant="smsBubble" selected width="xl" />
        <ResponsiveBox.Desktop>
          <div className={CN.smsText}>
            {smsCredits} {t('composite.purchaseSmsCreditDialog.credits')}
          </div>
        </ResponsiveBox.Desktop>
      </Button>

      {renderSmsModal && (
        <PurchaseSmsCreditDialog
          closePopup={toggleSmsModal}
          // FIXME
          // gotoBilling={() =>
          //   nav.push({
          //     pathname: linkTo({
          //       pattern: LINK.billing,
          //       salonId,
          //     }),
          //   })
          // }
          gotoBilling={() => {
            window.location.hash = `#/salon/${salonId}/settings/billing`;
          }}
          purchaseSmsBundle={purchaseSmsBundle}
          salonId={salonId}
          errorMessage={smsError}
          isFetching={isSmsFetching}
          sms_credits_available={smsCredits}
          permission={permission}
          variant={PURCHASE_VARIANTS.lowCredit}
          variantButton="lowCredit"
        />
      )}
    </div>
  );
};

const SmsBuyButtonHoc = connect(
  (state) => ({
    permission: selectEffectiveUserRole(state),
    smsCredits: selectClientCommsSmsCreditsAvailable(state),
    smsError: state.clientCommunications.errorMessage,
    isSmsFetching: state.clientCommunications.isFetching,
  }),
  mapActionsToDispatchToProps({
    purchaseSmsBundle,
  }),
)(SmsBuyButton);

export default SmsBuyButtonHoc;
